export default __webpack_public_path__ + "static/media/content-image_welcome-to-wbrcc.e7dcf67d.svg";